import React from 'react'
import './intro.scss'
import { init } from 'ityped';
import { useEffect, useRef } from 'react';

export default function Intro() {

    const textRef = useRef();

    useEffect(() => {
        init(textRef.current, {
            showCursor: true,
            strings: ["Developer", "Designer", "Content writer", "DevOps", "Yeah!"],
            backDelay: 1500,
            backSpeed: 60,
        });
    },[])
    return (
        <div className='intro' id="intro">
            <div className="left">
                <div className="imgContainer">
                    <img src="assets/rocky.png" alt="" />
                </div>
            </div>
            <div className='right'>
                <div className="wrapper">
                    <h2>Hi there, I am</h2>
                    <h1>Rocky Rai</h1>
                    <h3>Freelancer <span ref={ textRef}/></h3>
                   
                </div>
                <a href="#portfolio">
                    <img src="assets/down.png" alt="" />
                </a>
            </div>
        </div>
    )
}
